import React from "react";

export function Privacy() {
  return <Doc title="Privacy Policy" body={privacyBody} />;
}
export function Terms() {
  return <Doc title="Terms of Service" body={termsBody} />;
}

function Doc({ title, body }) {
  return (
    <div style={{ maxWidth: 780, margin: "30px auto", padding: "0 24px" }}>
      <div style={{ marginBottom: 28 }}>
        <div style={{ fontSize: 11, letterSpacing: "0.3em", color: "var(--gold)", marginBottom: 6 }}>OBITUARY RELIEF</div>
        <h1 className="serif" style={{ fontSize: 42, color: "#fff", margin: 0, fontWeight: 400 }}>{title}</h1>
        <div className="muted" style={{ marginTop: 8, fontSize: 13 }}>Effective {new Date().toLocaleDateString()}</div>
      </div>
      <article className="bg-card" style={{ padding: 36 }}>
        <div style={{ whiteSpace: "pre-wrap", color: "#dcdce0", fontSize: 15, lineHeight: 1.85, fontFamily: "Manrope" }}>{body}</div>
      </article>
    </div>
  );
}

const privacyBody = `Obituary Relief ("we," "us," "our") respects your privacy. This Privacy Policy explains what information we collect, how we use it, and your choices.

1. Information We Collect
• Account information: name, email, and password (hashed).
• Content: obituary text and images you create or upload.
• Billing: handled by Stripe — we never store your card number.

2. How We Use Your Information
• To provide and improve the service.
• To process payments via Stripe.
• To send transactional emails (e.g., password reset, share by email).

3. Data Storage & Security
• Your data is stored in encrypted databases. Passwords are hashed with bcrypt.
• Obituaries and photos are visible only to your account (and our owner support staff if you contact us).

4. Third-Party Services
• Stripe (payments) — see stripe.com/privacy
• Resend (email delivery) — see resend.com/legal/privacy-policy
• Anthropic Claude (AI writing) — content sent for generation is not used to train models.
• Google Gemini (AI portraits) — content sent for generation is not used to train models.

5. Your Rights
You may request export, correction, or deletion of your data at any time by emailing customerservice@obituaryrelief.com.

6. Changes
We may update this Policy. Material changes will be announced in-app or by email.

Contact: customerservice@obituaryrelief.com`;

const termsBody = `Welcome to Obituary Relief. By using our service, you agree to the following terms.

1. The Service
Obituary Relief is an AI-assisted tool that helps families and funeral professionals draft obituaries, memorial materials, and related content.

2. Subscription
• Price: $10 USD per month, auto-renewing.
• Billing is handled by Stripe.
• You may cancel at any time. Access continues until the end of the paid period.

3. Acceptable Use
You agree not to use Obituary Relief to publish defamatory, infringing, or unlawful content. AI-generated content should be reviewed by you for accuracy before publication.

4. Content Ownership
You retain ownership of the obituary text and photographs you create or upload. You grant us a limited license to host and process your content in order to provide the service.

5. AI Disclaimer
AI-generated drafts are starting points and may contain inaccuracies. You are responsible for final review.

6. Refunds
Subscription fees are non-refundable for partial periods. Contact customerservice@obituaryrelief.com for billing questions.

7. Limitation of Liability
Obituary Relief is provided "as is." To the extent permitted by law, we are not liable for indirect or consequential damages.

8. Changes
We may update these Terms. Continued use after changes constitutes acceptance.

Contact: customerservice@obituaryrelief.com`;
